(function () {
  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function syncCartState() {
    Array.prototype.slice.call(document.querySelectorAll("[data-bn-cart]")).forEach(function (root) {
      var countSource = root.querySelector("[data-bn-cart-count-source]");
      var count = countSource ? parseInt(countSource.textContent, 10) : 0;
      root.toggleAttribute("data-cart-empty", !count);
    });
  }

  onReady(syncCartState);

  document.addEventListener("cart:update", function () {
    window.requestAnimationFrame(syncCartState);
  });
})();
